import { createFileRoute } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { Badge } from "@/components/ui/badge";
import { AdminPageHeader } from "@/components/admin/admin-shell";
import { CrudManager } from "@/components/admin/crud-manager";
import { fetchAllUsers } from "@/lib/admin";

export const Route = createFileRoute("/_authenticated/admin/magazalar")({
  component: Page,
});

function Page() {
  const { data: users } = useQuery({ queryKey: ["admin", "users", "picker"], queryFn: fetchAllUsers });
  const ownerOptions = [
    { value: "", label: "— Sahib seçilməyib —" },
    ...(users ?? []).map((u) => ({
      value: u.id,
      label: `${u.full_name?.trim() || "Adsız istifadəçi"} · ${u.phone ?? u.id.slice(0, 8)}`,
    })),
  ];
  return (
    <div>
      <AdminPageHeader title="Mağazalar" description="Mağaza müraciətləri, planlar və təsdiq" />
      <CrudManager
        table="stores"
        addLabel="Yeni mağaza"
        emptyText="Hələ mağaza yoxdur."
        fields={[
          { name: "name", label: "Mağaza adı" },
          { name: "owner_id", label: "İstifadəçi (sahib)", type: "select", options: ownerOptions },
          { name: "slug", label: "Qısa ünvan (slug)" },
          { name: "phone", label: "Telefon" },
          { name: "whatsapp", label: "WhatsApp" },
          { name: "city", label: "Şəhər" },
          { name: "category", label: "Kateqoriya" },
          { name: "work_hours", label: "İş vaxtı" },
          { name: "logo_url", label: "Loqo linki" },
          { name: "banner_url", label: "Banner linki" },
          {
            name: "plan",
            label: "Plan",
            type: "select",
            options: [
              { value: "basic", label: "Standart" },
              { value: "premium", label: "Premium" },
              { value: "vip", label: "VIP" },
            ],
          },
          {
            name: "status",
            label: "Status",
            type: "select",
            options: [
              { value: "pending", label: "Gözləyir" },
              { value: "active", label: "Aktiv" },
              { value: "blocked", label: "Bloklanıb" },
            ],
          },
          { name: "verified", label: "Rəsmi nişan", type: "boolean" },
          { name: "description", label: "Təsvir", type: "textarea" },
        ]}
        columns={[
          { name: "name", label: "Ad" },
          { name: "city", label: "Şəhər" },
          { name: "plan", label: "Plan" },
          {
            name: "status",
            label: "Status",
            render: (r) => (
              <Badge
                className="rounded-full"
                variant={r["status"] === "active" ? "secondary" : r["status"] === "blocked" ? "destructive" : "outline"}
              >
                {r["status"] === "active" ? "Aktiv" : r["status"] === "blocked" ? "Bloklanıb" : "Gözləyir"}
              </Badge>
            ),
          },
          { name: "verified", label: "Nişan", render: (r) => (r["verified"] ? "Var" : "Yoxdur") },
          {
            name: "owner_id",
            label: "Sahib",
            render: (r) =>
              (users ?? []).find((u) => u.id === r["owner_id"])?.full_name ??
              (r["owner_id"] ? String(r["owner_id"]).slice(0, 8) : "—"),
          },
        ]}
      />
    </div>
  );
}
